module.exports = __webpack_public_path__ + "static/media/vidharbh.bad56c9d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/backs/vidharbh.jpg
// module id = 1005
// module chunks = 0